import { ServiceResponse } from '@nx-smartmonkey/shared/hooks';
import { useQuery } from '@tanstack/react-query';
import { vehicleService } from '../../../application/VehicleService';
import { DriverCredentials } from '../../../domain/credentials/DriverCredentials';
import { useErrorMiddleware } from '../../../hooks/useErrorMiddleware';
import { useShowSnackbarMessage } from '../../../hooks/useShowSnackbarMessage';
import { useRetrieveVehicle } from './useRetrieveVehicle';

type UseRetrieveDriverCredentialsResponseProps = ServiceResponse<Function, DriverCredentials>;

// Hooks act as 'Adapter' layer.
export const useRetrieveDriverCredentials = (): UseRetrieveDriverCredentialsResponseProps => {
  const { showSnackbarMessage } = useShowSnackbarMessage();
  const { data: vehicleData } = useRetrieveVehicle();
  const { sessionExpiredLogout } = useErrorMiddleware();

  const { data, isLoading, refetch, isSuccess, isError } = useQuery(
    [`driver_credentials`],
    () => vehicleService.retrieveCredentials(),
    {
      enabled: !!vehicleData,
      retry: false,
      staleTime: Infinity,
      refetchOnWindowFocus: false,
      onError: (err: any) => {
        console.info(`Driver Retrieve User Credentials Error: `, err?.response);

        if (err?.response?.status === 401) {
          sessionExpiredLogout();
          return;
        }

        showSnackbarMessage({
          messageIntlId: `infoerror.${err?.response?.data?.messageId ?? `network_error`}`,
        });
      },
    }
  );

  return {
    error: isError,
    success: isSuccess,
    isLoading,
    run: refetch,
    data: data,
  };
};
